<template id="main" class="top-up">
    <v-ons-page>
        <TopUpComponent />
    </v-ons-page>
</template>

<script>
import TopUpComponent from '@/components/TopUpComponent.vue';
import PurchaseComponent from "@/components/PurchaseComponent";
export default {
    components: {
        TopUpComponent,
        PurchaseComponent
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss">
.top-up {
    &-balance {
        min-height: 125px;
        text-align: center;

        h5 {
            font-size: 1.2em;
            font-weight: 400;
            line-height: 1.4em;
        }
        h2 {
            font-weight: bolder;
            font-size: 2em;
            margin-bottom: 0;
            margin-top: 0;
        }
        .btn {
            margin-top: 16px;
            background-color: #00c694;
            color: #ffffff;
        }
    }
}
</style>
